
<div class="container">
  <div class="search-form">
    <mat-form-field class="search-bar" appearance="outline">
      <button mat-icon-button (click)="search($event)"  matPrefix ><mat-icon>search</mat-icon></button>
      <input matInput (keyup)="checkSearchValue()"  (keydown.enter)="search($event)" placeholder="Search Buildings" (input)="setSearchField($event)" [value]="searchField">
      @if (searchField) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearchField()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <div class="button-bar">
    <button mat-raised-button (click)="changeStatus('ACTIVE')" [disabled]="!canChangeStatus('INACTIVE')"> Activate </button>
    <button mat-raised-button [disabled]="!canChangeStatus('ACTIVE')" (click)="changeStatus('FINALIZING')"> Finalize </button>
    <button mat-raised-button [disabled]="!canChangeStatus('FINALIZING')" (click)="changeStatus('COMPLETE')"> Complete </button>
    <button mat-raised-button (click)="showUnits()" [disabled]="!canShowUnits()"> Show Unit Log </button>
  </div>   
  <div class="patient-list">

    <table class="patient-table" mat-table [dataSource]="buildings" matSort (matSortChange)="changeSort($event)">
      <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      Select
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)"
                  >
      </mat-checkbox>
    </td>
  </ng-container>
      <ng-container matColumnDef="complex">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Complex </th>
        <td mat-cell *matCellDef="let building">{{building.complex}} </td>
      </ng-container>
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Code </th>
        <td mat-cell *matCellDef="let building"> {{building.buildingCode}} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td mat-cell *matCellDef="let building"> {{building.status}} </td>
      </ng-container>
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
        <td mat-cell *matCellDef="let building"> {{building.streetAddress1}} </td>
      </ng-container>
      <ng-container matColumnDef="units">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Completed Units </th>
        <td mat-cell *matCellDef="let building"> {{getUnitsCompleteCount(building)}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="selectedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: selectedColumns;"></tr>
    </table>
    </div>
</div>
